// src/pages/FormAccepted.jsx
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Testimonials from '../components/Testimonials';

const FormAccepted = () => {
    return (
        <>
            <Helmet>
                <title>New Patient Form Accepted | Redemption Psychiatry</title>
            </Helmet>
            <div className="wrap">
                <Header />
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    <div id="content" role="main" className="home">

                        {/* Interior Header */}
                        <div id="interior-header-container" className="container-fluid">
                            <div className="container">
                                <h1>New Patient Form Accepted</h1>
                            </div>
                        </div>

                        {/* FormAccepted Introduction */}
                        <div id="FormAccepted-introduction-container" className="container text-center">
                            <div>
                                <div>
                                    <h3 className="text-center">
                                        Thank you for submitting your information; we have received it successfully.</h3><p> One of our team members will review your submission and contact you by phone within 24 to 48 hours to discuss the next steps.
                                        During the call, we will confirm your details, discuss your health needs, and schedule your initial consultation.
                                        If you have any questions or need to provide additional information, please don't hesitate to contact us at: <br /> <a href="tel:+16025603445" style={{ textDecoration: 'none', fontWeight: 'bold' }}>(602) 560-3445</a></p>
                                       
                                    
                                </div>
                            </div>
                        </div>

                        {/* Testimonials Section (reused) */}
                        <Testimonials />

                    </div> {/* End #content */}
                    <div className="push"></div>
                </motion.div>
                <Footer />
            </div>
        </>
    );
};

export default FormAccepted;
